import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import { connect, useDispatch } from 'react-redux';
import { submit } from 'redux-form';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { addOrderFormStep } from '../../actions/stepActions';
import formSteps from '../../../shared/helpers/formSteps';
import BottomNavigation from '../BottomNavigation/BottomNavigation';
import DetailsSubHeader from '../DetailsSubHeader/DetailsSubHeader';
import TopHeader from '../TopHeader/TopHeader';
import TopNavigation from '../TopNavigation/TopNavigation';

function PageLayout({
  children, allowedSteps, addNextStep,
}) {
  const history = useHistory();
  const { params } = useRouteMatch({
    path: '/:companyName/:page',
    strict: true,
    sensitive: true,
  });
  const dispatch = useDispatch();
  const step = formSteps.findIndex((el) => el.replace('/', '') === params.page);
  useEffect(() => {
    if (allowedSteps.length < step + 1) {
      history.push(`/${params?.companyName}/`);
    }
  });
  const fwdBtn = (
    <div className="bottom_navigation__loading">
      {step === 4 ? 'Submit ' : 'Continue '}
      <TiArrowRight
        style={{
          verticalAlign: 'sub',
          display: 'inline-block',
        }}
        size={22}
      />
    </div>
  );
  return (
    <div className="container-fluid">
      <TopNavigation stepNumber={step} />
      <TopHeader />
      <DetailsSubHeader />
      {children}
      <BottomNavigation
        btnBackTxt="Previous"
        btnFwdText={fwdBtn}
        goForward={() => {
          addNextStep(step + 1);
          dispatch(submit('WizardOrderForm'));
        }}
        goBack={() => history.push(`/${params?.companyName}${formSteps[step - 1]}`)}
      />
    </div>
  );
}

PageLayout.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  addNextStep: PropTypes.func.isRequired,
  allowedSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
};
PageLayout.defaultProps = {};

export default connect(
  (state) => ({ allowedSteps: state.steps }),
  {
    addNextStep: addOrderFormStep,
  },
)(PageLayout);
